<template>
  <div class="">
    <div class="is-flex is-justify-content-space-between is-align-items-center mb-4">
      <div>
        <p class="has-text-grey has-text-weight-semibold is-uppercase is-size-7">Información</p>
        <h2 class="title is-4 mb-2">Información general</h2>
        <p class="has-text-grey is-size-7">Edita los datos base de la reunión.</p>
      </div>
      <div v-if="localMeeting.portada" class="cover-preview">
        <figure class="image is-96x96">
          <img :src="localMeeting.portada" :alt="localMeeting.titulo" />
        </figure>
      </div>
    </div>

    <form class="columns is-multiline" @submit.prevent="save">
      <b-field class="column is-12" label="Título *" label-position="horizontal">
        <b-input v-model="localMeeting.titulo" required></b-input>
      </b-field>

      <b-field class="column is-6" label="Fecha *" label-position="horizontal">
        <b-input v-model="localMeeting.fecha" type="date" required></b-input>
      </b-field>

      <b-field class="column is-6" label="Lugar *" label-position="horizontal">
        <b-input v-model="localMeeting.lugar" required></b-input>
      </b-field>

      <b-field class="column is-12" label="Descripción" label-position="horizontal">
        <b-input v-model="localMeeting.descripcion" type="textarea"></b-input>
      </b-field>

      <div class="column is-12">
        <ImageInput
          label="Portada"
          infoText="JPG o PNG, máximo 2MB."
          name="imagenes_id"
          id="imagenes_id"
          imageType="imagenes_id"
          :initial-url="localMeeting.portada"
          @file-selected="handleFileSelected"
        />
      </div>

      <b-field class="column is-12" label="Estatus" label-position="horizontal">
        <b-switch v-model="localMeeting.activo">Activado</b-switch>
      </b-field>

      <div class="column is-12">
        <div class="buttons is-right">
          <b-button type="is-text" @click="reset">Restablecer</b-button>
          <b-button type="is-primary" native-type="submit" icon-left="content-save">Guardar cambios</b-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Swal from 'sweetalert2';
import ImageInput from '@/components/common/imageInput.vue';

export default {
  components: {
    ImageInput,
  },
  props: {
    meeting: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      localMeeting: {},
      fallback: {
        id: null,
        titulo: '',
        fecha: '',
        lugar: '',
        descripcion: '',
        portada: '',
        activo: true,
        imagenFile: null,
      },
    };
  },
  watch: {
    meeting: {
      immediate: true,
      handler(newValue) {
        this.localMeeting = { ...this.fallback, ...(newValue || {}) };
      },
    },
  },
  methods: {
    ...mapActions({
      saveMeeting: 'meetings/saveMeeting',
    }),
    async save() {
      const response = await this.saveMeeting(this.localMeeting);

      Swal.fire({
        icon: response.status ? 'success' : 'error',
        title: response.message,
        confirmButtonColor: '#268af7',
      });

      if (response.status) {
        this.$emit('updated', response.data);
      }
    },
    reset() {
      this.localMeeting = { ...this.fallback, ...(this.meeting || {}) };
    },
    handleFileSelected(fileData) {
      this.localMeeting.imagenFile = fileData?.file || null;
    },
  },
};
</script>

<style scoped>
.cover-preview img {
  object-fit: cover;
  border-radius: 10px;
  height: 96px;
  width: 96px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
}
</style>
